// src/resources/bookings/components/BookingFilters.tsx
import { Filter, SearchInput, SelectInput } from "react-admin";
import { BOOKING_STATUS_CHOICES } from "../statuses";

interface BookingFiltersProps {
  [key: string]: unknown;
}

export const BookingFilters = (props: BookingFiltersProps) => (
  <Filter {...props}>
    <SearchInput
      source="search"
      placeholder="Search by booking ID, provider order ID or customer email"
      alwaysOn
    />
    <SelectInput source="status" choices={BOOKING_STATUS_CHOICES} alwaysOn />
  </Filter>
);
